import {
  BodyLoadingClass,
  GlobalLoadingModalHiddenClass,
  GlobalLoadingModalId,
} from 'src/constants'
import { useGlobalLoadingStore } from 'src/hooks/stores/useGlobalLoadingStore'

export const useGlobalLoading = () => {
  const { globalLoadingStoreValue, setGlobalLoadingStoreValue } = useGlobalLoadingStore()

  const showGlobalLoading = () => {
    const loadingModal = document.querySelector(`#${GlobalLoadingModalId}`) as HTMLElement | null
    if (loadingModal) {
      // ブロッキングローディングを表示する
      loadingModal.classList.remove(GlobalLoadingModalHiddenClass)
    }
    const body = document.querySelector('body') as HTMLElement | null
    if (body) {
      // bodyをローディング設定にする
      body.classList.add(BodyLoadingClass)
    }
  }

  const hideGlobalLoading = () => {
    const loadingModal = document.querySelector(`#${GlobalLoadingModalId}`) as HTMLElement | null
    if (loadingModal) {
      // ブロッキングローディングを非表示にする
      loadingModal.classList.add(GlobalLoadingModalHiddenClass)
    }
    const body = document.querySelector('body') as HTMLElement | null
    if (body) {
      // bodyをローディング設定から解除する
      body.classList.remove(BodyLoadingClass)
    }
  }

  const disableAutoInitialHide = () => {
    setGlobalLoadingStoreValue({
      ...globalLoadingStoreValue,
      isAutoInitialHideEnabled: false,
    })
  }

  return {
    showGlobalLoading,
    hideGlobalLoading,
    isAutoInitialHideEnabled: globalLoadingStoreValue.isAutoInitialHideEnabled,
    disableAutoInitialHide,
  }
}
